import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { sessionActions } from 'store';
import { trialStatusEnums, useModal } from 'utils';
import { CustomDelete, FullTable } from 'components';
import { DELETE_TRIAL_LOG_ACTION_TYPE, historyLogNotYet, rateHistoryHead, trialHistoryBody, trialHistoryHead } from './constants';

export const TrialHistoryLog = ({ goal }) => {
    const sessionById = useSelector((state) => state.session.sessionById);
    const dispatch = useDispatch();
    const { open } = useModal();
    // Show only finalised trials. IN_PROGRESS rows are mid-collection and
    // surface as garbage in this view: missing endTime, checkpoint values
    // shown as "real" answers, and they confuse trial counts / averages.
    const completedTrials = (goal?.tSummary?.trials || []).filter(
        (t) => (t?.status || trialStatusEnums.COMPLETED) === trialStatusEnums.COMPLETED,
    );

    const actionForHistoryLog = (item, name) => {
        if (name === 'delete') {
            open(
                <CustomDelete
                    info="Delete this Log?"
                    text="Are you sure you want to delete this log?"
                    handleDel={() => dispatch(sessionActions.deleteTrialLog(sessionById?.id, goal?.tSummary?.id, item?.id))}
                    actionType={DELETE_TRIAL_LOG_ACTION_TYPE}
                />
            );
        }
    };

    return (
        <div style={{ width: 1200, maxWidth: '100%' }}>
            <div className="space-between">
                <p className="modal-header-title">History Log</p>
            </div>

            <div>
                <FullTable
                    head={trialHistoryHead(sessionById, goal?.tSummary?.dataType)}
                    body={trialHistoryBody(sessionById, goal?.tSummary?.dataType)}
                    list={completedTrials}
                    notYet={historyLogNotYet}
                    handleClickButton={actionForHistoryLog}
                    height={'auto'}
                    activeRowId={''}
                    margin={'16px 0 0 0'}
                />
            </div>
        </div>
    );
};
